import React from 'react'
import { StyleProp, StyleSheet } from 'react-native'

function ShimmerPlaceHolder({ style }: { style: StyleProp<any> }) {
  return <div style={StyleSheet.flatten(style)} className="shimmer" />
}

export default ShimmerPlaceHolder
